export default __webpack_public_path__ + "static/media/phone4.1b2b5476.svg";